import { render, staticRenderFns } from "./AnswerPlayer.vue?vue&type=template&id=9c4a9296&scoped=true"
import script from "./AnswerPlayer.vue?vue&type=script&lang=js"
export * from "./AnswerPlayer.vue?vue&type=script&lang=js"
import style0 from "./AnswerPlayer.vue?vue&type=style&index=0&id=9c4a9296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4a9296",
  null
  
)

export default component.exports